import React from "react";
// import lands from "./data";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";


import test2 from "../../assets/landing5.png";
import test3 from "../../assets/patio.jpeg";
import test1 from "../../assets/landing6.jpeg";

import "./landing.css"

const Landing = () => {
  return (
    <Carousel autoPlay infiniteLoop interval={1500} showArrows={false} showStatus={false} >
      <div  className="landing_slide">
        <img
          src={test1}
         
          alt="landing images 1"
        />
       
      </div>
      <div  className="landing_slide">
        <img
          src={test2}
          alt="landing images 2"
        />
    
      </div>
      <div  className="landing_slide">
        <img
          src={test3}
          alt="landing images 3"
        />
 
      </div>
    </Carousel>
  );
};

export default Landing;
